import { render, staticRenderFns } from "./FavouriteToggle.vue?vue&type=template&id=70b1c106&scoped=true"
import script from "./FavouriteToggle.vue?vue&type=script&lang=js"
export * from "./FavouriteToggle.vue?vue&type=script&lang=js"
import style0 from "./FavouriteToggle.vue?vue&type=style&index=0&id=70b1c106&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b1c106",
  null
  
)

export default component.exports